import { render } from "./CreateClient.vue?vue&type=template&id=1abee311&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"

import "./CreateClient.vue?vue&type=style&index=0&id=1abee311&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abee311"]])

export default __exports__